module.exports = __webpack_public_path__ + "img/loading_bg.18a33d1a.png";